"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postLinkStyles = void 0;
const lit_1 = require("lit");
const shared_styles_1 = require("@/stylesheets/shared.styles");
/**
 * post 계열이 공유하는 링크 표면. 글 카드 전체가 하나의 링크가 되므로
 * 색은 흐르는 값을 따르고, hover 배경은 레이아웃 박스를 밀지 않도록
 * inset된 ::before 레이어로 깐다. 여백은 소비처가 `--post-link-inset`으로 넓힌다.
 */
exports.postLinkStyles = (0, lit_1.css) `
  .link {
    --post-link-background-color: transparent;
    --post-link-inset: 0px;

    display: flex;
    border-radius: var(--radius);
    color: inherit;
    ${shared_styles_1.layerContainerStyles};
  }

  .link::before {
    border-radius: var(--radius);
    background-color: var(--post-link-background-color);
    ${shared_styles_1.backgroundLayerStyles};
    inset: 0 calc(var(--post-link-inset) * -1);
  }

  a.link:hover {
    --post-link-background-color: var(--interaction-hover-background-color);
  }

  a.link:focus-visible {
    outline: var(--interaction-focus-outline);
    outline-offset: -1px;
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicG9zdC5zdHlsZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJwb3N0LnN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSw2QkFBeUI7QUFFekIsK0RBQXlGO0FBRXpGOzs7O0dBSUc7QUFDVSxRQUFBLGNBQWMsR0FBRyxJQUFBLFNBQUcsRUFBQTs7Ozs7Ozs7TUFRM0Isb0NBQW9COzs7Ozs7TUFNcEIscUNBQXFCOzs7Ozs7Ozs7Ozs7Q0FZMUIsQ0FBQSJ9